/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Announcements_Updated_AtInputs */

const fr_announcements_updated_at = /** @type {(inputs: Announcements_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mise à jour le ${i?.date}`)
};

const en_announcements_updated_at = /** @type {(inputs: Announcements_Updated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Updated on ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Updated on {date}" |
*
* @param {Announcements_Updated_AtInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const announcements_updated_at = /** @type {((inputs: Announcements_Updated_AtInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Announcements_Updated_AtInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_announcements_updated_at(inputs)
	return en_announcements_updated_at(inputs)
});